
export const theme = {
  colors: {
    primary: 'blue-400',
    primaryHover: 'blue-500',
    accent: 'rose-500',
    bg: 'gray-50',
    card: 'white',
    text: {
      main: 'gray-900',
      secondary: 'gray-600',
      muted: 'gray-400',
    }
  },
  styles: {
    card: 'bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-300',
    container: 'max-w-6xl mx-auto px-4 sm:px-6 lg:px-8',
    heading: 'text-3xl font-serif font-bold tracking-tight',
    button: 'inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200',
  }
};